import { useState } from 'react'
import { useIntl } from 'react-intl'

import type { TagToastContentProps } from './TagToastContent.types'

export const TagToastContent = (props: TagToastContentProps) => {
  const { message, onUndo } = props
  const intl = useIntl()
  const [undoClicked, setUndoClicked] = useState(false)

  const handleUndo = () => {
    if (undoClicked) {
      return
    }

    setUndoClicked(true)
    onUndo()
  }

  return (
    <>
      {message}
      <button
        className="Toast-action"
        disabled={undoClicked}
        onClick={handleUndo}
        type="button"
      >
        {intl.formatMessage({ id: 'Tags_undo' })}
      </button>
    </>
  )
}
